import { Playground } from 'docz';
import { Field, Control, FieldBody, SelectBox, Checkbox, Radio } from "../../../../../src/components/Form";
import * as React from 'react';
export default {
  Playground,
  Field,
  Control,
  FieldBody,
  SelectBox,
  Checkbox,
  Radio,
  React
};